import React from "react";

const ColorBar = ({ fastHighlighting, highlightColor }) => {
  const colors = {
    "#ff7979": "#E22D2D",
    "#80e1fd": "#03C5F2",
    "#47e6b4": "#04BC99",
    "#f4ed75": "#FFD110",
    "#ffa0ea": "#F45BF4",
    "#aca6ff": "#8C64D8",
    "#e5be8b": "#A87640",
    "#a1ec80": "#48C60E",
    "#ffc766": "#FF9203",
    "#8ac6ff": "#0461AD"
  };

  return (
    <div>
      <div
        id="fast-highlighting-color-bar"
        style={{
          position: "relative",
          bottom: "-5px",
          width: "32px",
          borderBottom: fastHighlighting
            ? "3px solid " + colors[highlightColor]
            : "0"
        }}
      />
    </div>
  );
};

export default ColorBar;
